<template>
  <v-container class="background black--text pb-lg-0" id="home-container">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <v-row>
      <!-- cards 1, 2 & 3 - this only displays on large -->
      <!-- card 2 - large only -->
      <v-row class="d-flex d-lg-flex d-xl-flex lg-top-row">
        <!-- table of contents -->

        <v-row class="flex-column pr-lg-0 mt-1 mb-4 mx-4">
          <v-col cols="12" class="px-0">
            <div class="topbar"></div>
            <v-card tile class="set-vcard-height d-flex flex-column">
              <v-card-title class="pb-0 help-ipad-land justify-center"
                >RSONU Mission Statement</v-card-title
              >
              <div class="d-flex flex-column flex-lg-row img-text">
                <!-- text -->
                <!-- IF WE GET NEW LOGO CHANGE COLS LG="12" TO 8 -->
                <!-- IF THEY WANT LOGO HIDDEN AGAIN CHANGE COLS LG="8" TO 12 AND SEE LINE 73 -->
                <v-col cols="12" lg="8" class="pt-lg-0">
                  <v-card-text
                    class="help-text black--text pt-lg-0 d-flex flex-column"
                    ><span>
                      The RSONU (Regional Sex Offender Notification Unit) was
                      founded in 1998. At that time, the City of Reno, City of
                      Sparks, and Washoe County, all agreed there was a need for
                      coordination in Law Enforcement in the tracking,
                      monitoring, investigation, public notification, and the
                      arrest and prosecution of non-compliant sex offenders. The
                      RSONU operates as a regional, multi-jurisdictional and
                      collaborative entity to carry out the requirements of
                      community notifications as set forth in Chapter 179D of
                      the Nevada Revised Statutes. The RSONU’s jurisdictional
                      boundaries encompass all of Washoe County, including the
                      cities of Reno and Sparks.
                    </span>
                    <hr class="my-2" />
                    <span>
                      In addition to the Reno Police Department (RPD)
                      Detectives, Detectives from the Sparks Police Department
                      provide the unit with clerical support.
                    </span>

                    <hr class="my-2" />
                    <span class="mb-1"
                      >The RSONU is open Monday through Thursday, 7am to 5pm,
                      excluding holidays, and can be reached by calling
                      <a href="tel:+17754339543">775-433-9543</a> or emailing
                      <a target="_blank" href="mailto:RPDSONU@reno.gov"
                        >RPDSONU@reno.gov</a
                      > </span
                    ><br />
                    <span
                      >Currently there are over 1,700 registered sex offenders
                      in the Reno, Sparks, and Washoe County area. Each of the
                      Detectives are assigned over 400 sex offenders to
                      monitor.</span
                    >
                  </v-card-text>
                </v-col>

                <!-- img -->
                <!-- add DISPLAY NONE if they want this hidden again -->
                <v-col cols="12" lg="4" class="d-flex justify-center">
                  <img class="mt-n4" src="../images/RPD-RSONU-02_25-700.png" />
                </v-col>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-row>

      <!-- card 2 -->
      <!-- hidden on large -->
    </v-row>

    <!-- card 3 -->
    <!-- hidden on large -->
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  .topredbar {
    height: 18px;
    background-color: #791e15;
  }

  .topbar {
    height: 18px;
    background-color: #708e92;
  }

  .toc-links {
    width: 100%;
  }

  .toc-links a {
    width: 100%;
    color: #039be5;
    text-transform: uppercase;
  }

  .help-text {
    font-weight: 400;
    font-size: 0.95rem;
    line-height: 1.2rem;
  }

  .img-text {
    width: 100%;
    flex-wrap: wrap;
  }

  .img-text img {
    width: 65%;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .img-text img {
    width: 45%;
  }

  .help-text {
    font-size: 1.2rem;
  }
}

@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  #home-container {
    max-width: 1000px;
  }
  .lg-top-row {
    width: 100%;
    margin: 0 auto;
    flex-wrap: nowrap;
  }
  .set-vcard-height {
    height: auto;
  }

  .help-text {
    font-size: 0.95rem;
  }

  .img-text img {
    width: 210px;
    height: 210px;
    align-self: center;
  }

  .help-ipad-land {
    padding-top: 0 !important;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
  .lg-top-row {
    width: 100%;
    margin: 0 auto;
    flex-wrap: nowrap;
  }

  .set-vcard-height {
    height: auto;
  }

  .img-text img {
    width: 250px;
    height: 250px;
    align-self: center;
  }

  .help-text {
    font-size: 1rem;
  }
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "frontdeskcards",
  mixins: [bus_common],
  data() {
    return {};
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    init() {},
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
